export default function hideEquipmentButton(st) {
  st.Buttons.equipment = "hidden-btn";
}
